import React from "react";
import Body from "./Body";
import Reports from "../Reports/Reports";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

const ReportsPage = () => {
  const { token } = useSelector((state) => state.users);

  if (!token) {
    return <Redirect to='/login' />;
  } else {
    return (
      <Body state={4}>
        <Reports />
      </Body>
    );
  }
};

export default ReportsPage;
